/**
 * <cd-kit-spread>
 *
 * Tap-to-flip polaroid spread for the "what's in the kit" section.
 * Each polaroid is a <button> with two faces (front photo + back
 * story). Click/keyboard activates the button → toggle `is-flipped`
 * on the wrapping card → CSS rotateY does the visual flip.
 *
 * Why a web component (and not just a click handler in section JS)
 *   - State scoped per section instance (multiple kit-spread sections
 *     on one page wouldn't fight)
 *   - Cleanup on disconnect (SPA-safe; section removal doesn't leak
 *     listeners)
 *   - Matches the convention used by cd-inquiry-form / cd-product-
 *     reviews-fetcher / cd-quote-calculator
 *
 * No dependencies. ~50 lines of behavior.
 */
(function () {
  if (customElements.get('cd-kit-spread')) return;

  class CDKitSpread extends HTMLElement {
    connectedCallback() {
      this._onClick = this.onClick.bind(this);
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }

    onClick(e) {
      var btn = e.target.closest('[data-cd-flip]');
      if (!btn) return;
      // The button is the actual focusable/clickable element. Toggle
      // is-flipped on the WRAPPING card so the tilt rotation on the
      // wrap composes with the rotateY(180deg) on the inner 3d
      // container — keeps the polaroid's hand-stuck angle intact
      // while the faces swap.
      var card = btn.closest('.cd-kit-spread__card');
      if (!card) return;
      var flipped = card.classList.toggle('is-flipped');
      btn.setAttribute('aria-pressed', flipped ? 'true' : 'false');
      // Move focus state inside the now-visible face for screen readers
      // by updating the aria-label so the announce reads the right
      // side.
      var label = card.getAttribute('data-flip-label-' + (flipped ? 'back' : 'front'));
      if (label) btn.setAttribute('aria-label', label);
    }
  }

  customElements.define('cd-kit-spread', CDKitSpread);
})();
